import React from "react";
import { Card, CardContent, Typography, Box, Chip, Stack } from "@mui/material";
import { money } from "../../../../utils/money";

export default function ReviewLogisticsSummary({
  logisticsChips = [],
  deliveryLine,
  setupLine,
  deliveryFee,
  setupFee,
}) {
  console.log(deliveryFee, setupFee);
  return (
    <Card variant="outlined" sx={{ borderRadius: 3, mb: 2 }}>
      <CardContent sx={{ p: 2.25 }}>
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          sx={{ mb: 1 }}>
          <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>
            Delivery & setup
          </Typography>
          <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>
            {money(deliveryFee + setupFee)}
          </Typography>
        </Stack>
        {logisticsChips.length ? (
          <Box sx={{ mt: 1, display: "flex", gap: 1, flexWrap: "wrap" }}>
            {logisticsChips.map((txt) => (
              <Chip key={txt} size="small" label={txt} />
            ))}
            {deliveryLine && (
              <Chip
                size="small"
                color="default"
                label={`Delivery fee: $${Number(
                  deliveryLine.totalPrice
                ).toFixed(2)}`}
              />
            )}
            {setupLine && (
              <Chip
                size="small"
                color="default"
                label={`Setup: $${Number(setupLine.totalPrice).toFixed(2)}`}
              />
            )}
          </Box>
        ) : (
          <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
            Pickup — no delivery/setup selected.
          </Typography>
        )}
      </CardContent>
    </Card>
  );
}
